export default __webpack_public_path__ + "static/media/online-live-video-marketing-concept_12892-37.216a598a.jpg";